module.exports = __webpack_public_path__ + "img/landing-invest-reviews.78344ea0.svg";